export default {
  agenda: 'Agenda',
  back: 'Atrás',
  cancel: 'Cancel',
  change_status: 'Change status',
  close: 'Cerrar',
  create: 'Crear',
  day: 'Día',
  delete: 'Eliminar',
  digits_only: '{label} should have digits only',
  edit: 'Editar',
  email: 'Email',
  empty_rows: 'No data available in table',
  expand: 'Expandir',
  filter: 'Fitlrar',
  filters: 'Filtros',
  month: 'Mes',
  next: 'Siguiente',
  open: 'Abrir',
  pagination_label_template: '{first} a {last} de {totalRecords}',
  password_policy_minimum_length: '{{value}} characters minimum',
  password_policy_minimum_lowercase: 'At least {{value}} lowercase letter (a-z)',
  password_policy_minimum_uppercase: 'At least {{value}} uppercase letter (A-Z)',
  password_policy_minimum_numbers: 'At least {{value}} number (0-9)',
  password_policy_minimum_special_chars: 'At least {{value}} special character ({{chars}})',
  powered_by: 'Potenciado por Sepia v.{{version}}',
  reset_filters: 'Reset filters',
  save: 'Guardar',
  search: 'Search',
  timeline_week: 'Timeline week',
  today: 'Today',
  warning: 'Warning',
  week: 'Week',
  work_week: 'Work week',
  view: 'View',
  year: 'Year',
};